import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom'
import Dashboard from '../../Dashboard/Dashboard'
import UserMaster from '../../UserManagement/UserMaster'
import ExpenseMaster from '../../ExpenseManagement/ExpenseMaster'
import AddExpense from '../../ExpenseManagement/AddExpense'
import RoleMaster from '../../RoleManagement/RoleMaster'
import AddRole from '../../RoleManagement/AddRole'
import EditRole from '../../RoleManagement/EditRole'
import BussinessAccount from '../../BusinessAccount/BussinessAccount'
import CashbookManagement from '../../CashbookManagement/CashbookManagement'
import CashMaster from '../../CashbookManagement/CashMaster'
import Test from '../../../Test'
import AddBooks from '../../Books/AddBooks'
import BookManagement from '../../Books/BookManagement'

function PanelNavigation() {
  return (
    <Routes>
      <Route path="/" element={<Dashboard />} />
      <Route path='/users' element={<UserMaster />} />
      <Route path='/expense' element={<ExpenseMaster />} />
      <Route path='/expense/add' element={<AddExpense />} />
      <Route path='/expense/edit/:id' element={<AddExpense />} />
      <Route path='/role' element={<RoleMaster />} />
      <Route path='/role/add' element={<AddRole />} />
      <Route path='/role/edit/:id' element={<EditRole />} />
      <Route path='/account' element={<BussinessAccount />} />
      <Route path='/cashbook' element={<CashbookManagement />} />
      <Route path='/cashbook/cashIn' element={<CashMaster />} />
      <Route path='/cashbook/cashOut' element={<CashMaster />} />
      <Route path='/cashbook/edit/:id' element={<CashMaster />} />
      <Route path='/book' element={<BookManagement />} />
      <Route path='/test' element={<Test />} />









    </Routes>
  )
}

export default PanelNavigation
